import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { WrappedInput } from 'src/share/components/Input/Input';
import { IAgency } from 'src/share/types/agency';
import { IManager, ManagersTypes } from 'src/share/types/manager';

export interface IManagerFormProps {
  managerInfo: IManager;
  onHandleManagerInfo: (path: string, value: any) => void;
  onHandleManagerUserType: (userType: ManagersTypes) => void;
  isAdminForm: boolean;
  loading: boolean;
  isEditForm: boolean;
  agencies: any;
  userType: string;
}

const ManagerForm = (props: IManagerFormProps) => {
  const getAgenciesOptions = (agencies: IAgency[] | IAgency) => {
    if (!agencies) {
      return false;
    } else {
      if (Array.isArray(agencies)) {
        return agencies.map((agency) => {
          return <option key={agency.code} value={agency.code}>{agency.name}</option>
        });
      } else {
        return <option key={agencies.code} value={agencies.code}>{agencies.name}</option>
      }
    }
  }
  const form = (key: string, placeholder: string, required: boolean = true) => {
    const { managerInfo, loading } = props;
    return {
      id: key,
      name: key,
      md: 12,
      placeholder: placeholder ? placeholder : key,
      value: managerInfo[key],
      onChange: (e: any) => props.onHandleManagerInfo(key, e.target.value),
      required,
      disabled: loading
    }
  }
  return (
    <Row>
      <Col md="12" className="subFont">
        <WrappedInput type="text" {...form('name', 'Enter name')} />
        <WrappedInput type="email" {...form('email', 'Enter email')} />
        {props.isAdminForm &&
          <WrappedInput
            type="select"
            {...form('userType', 'Select User Type')}
            onChange={event => {
              props.onHandleManagerUserType(event.target.value as ManagersTypes)
            }}
            disabled={props.isEditForm || props.loading}
            value={props.userType}
          >
            <option value="">Select User Type...</option>
            {Object.keys(ManagersTypes).map(managerType =>
              <option key={ManagersTypes[managerType]} value={ManagersTypes[managerType]}>
                {ManagersTypes[managerType]}
              </option>)}
          </WrappedInput>}
        {(props.userType === ManagersTypes.CASEMANAGER) &&
          <WrappedInput
            type="select"
            {...form('agencyCode', 'Select one')}
            value={props.managerInfo.agencyCode}
            onChange={event => {
              props.onHandleManagerInfo('agencyCode', event.target.value)
            }}
            disabled={props.isEditForm || props.loading}
          >
            <option value="">Select One...</option>
            {getAgenciesOptions(props.agencies)}
          </WrappedInput>}
        <WrappedInput type="text" {...form('phone', 'Enter phone number', false)} />
        <WrappedInput type="textarea" {...form('address', 'Address', false)} />
      </Col>
    </Row>
  );
}

export default ManagerForm;



// WEBPACK FOOTER //
// ./src/modules/Agencies/Manager/Add/components/ManagerForm.tsx